import React from 'react';
import PropTypes from 'prop-types';
// import { PlusCircleOutlined } from '@ant-design/icons';

import { Collapse, Button, Modal, Card, Tag } from 'antd';
import { Document, Outline, Page } from 'react-pdf';
import {
  LeftOutlined,
  RightOutlined,
  DownloadOutlined,
} from '@ant-design/icons';
import QuoteDetailForm from '../../components/forms/EditQuoteForm';
import './ContractQuote.scss';
import RFQDetailTable from '../../components/grids/RFQDetailsGrid';
import ContractQuoteHOC from './ContractQuoteHOC';
import { tomcatHost, cloudFrontCdnUrl } from '../../config/properties';
import history from '../../config/history';
import Loading from '../../components/Loading';
import FileDetector from '../../components/fileDetector';

const { Panel } = Collapse;
function ContractQuote(props) {
  const {
    auth,
    initialValues,
    handleFormSubmit,
    confirmQuoteSubmit,
    confirmQuoteCancel,
    rfqDetails,
    changeDate,
    saveQuote,
    discardQuote,
    ndaObj,
    showPdfModal,
    viewPDF,
    downloadNDA,
    onDocumentLoadSuccess,
    pageNumber,
    numPages,
    previousPage,
    nextPage,
    loading,
    readOnly,
    rfqObject,
    totalCost,
    attachments,
    downloadAttachments,
    rfqComment,
    downloadingAttachment
  } = props;

  console.log(rfqObject);
  return (
    <div className="edit-contract-wrapper">
      <div id="mybutton">
        <Button
          className="floating-back"
          onClick={() => {
            history.goBack();
          }}
        >
          Go Back
        </Button>
      </div>
      {loading && <Loading text="Locating Quote and RFQ Data" />}
      {!loading && (
        <Collapse defaultActiveKey={['1', '2']}>
          <Panel
            header={
              <div style={{ display: 'flex' }}>
                {' '}
                <div style={{ display: 'flex' }}>
                  <div style={{ marginRight: '64px' }}> Quote Details </div>{' '}
                  <div style={{ marginRight: '32px' }}>
                    RFQ Description: <Tag> {rfqObject.description}</Tag>
                  </div>{' '}
                  <div style={{ marginRight: '32px' }}>
                    Company: <Tag> {rfqObject.companyName}</Tag>
                  </div>{' '}
                  <div style={{ marginRight: '32px' }}>
                    Quote Due Date: <Tag>{rfqObject.quoteDueDate}</Tag>
                  </div>{' '}
                </div>
                <div style={{ marginRight: '32px' }}>
                  Status:{' '}
                  <Tag
                    color={
                      initialValues.status === 'Cancelled' ||
                        initialValues.status === 'Declined'
                        ? 'red'
                        : initialValues.status === 'Awarded'
                          ? 'green'
                          : ''
                    }
                  >
                    {initialValues.status}
                  </Tag>
                </div>
              </div>
            }
            key="1"
          >
            <QuoteDetailForm
              totalCost={totalCost}
              initialValues={initialValues}
              onSubmit={handleFormSubmit}
              changeDate={changeDate}
              ndaObj={ndaObj}
              viewPDF={viewPDF}
              readOnly={readOnly}
            />
            {readOnly &&
              (initialValues.status === 'Cancelled' ||
                initialValues.status === 'Declined') && (
                <div className="quote-button-wrapper">
                  {' '}
                  <Button type="primary" danger onClick={confirmQuoteCancel}>
                    Cancel Quote
                  </Button>
                </div>
              )}
            {!readOnly && (
              <div className="quote-button-wrapper">
                <Button type="primary" danger onClick={confirmQuoteCancel}>
                  Cancel Quote
                </Button>
                <Button
                  type="primary"
                  style={{
                    background: '#ff7c52',
                    color: 'white',
                    borderColor: '#ff7c52',
                  }}
                  onClick={discardQuote}
                >
                  Discard Changes
                </Button>
                <Button type="primary" onClick={saveQuote}>
                  Save Changes
                </Button>
                <Button
                  style={{
                    background: '#2ebd38',
                    color: 'white',
                    borderColor: '#2ebd38',
                  }}
                  onClick={confirmQuoteSubmit}
                >
                  Submit Quote
                </Button>
              </div>
            )}
          </Panel>
          <Panel header="RFQ Details" key="2">
            <RFQDetailTable rfqDetails={rfqDetails} />
            <div style={{ display: 'flex' }}>
              {' '}
              <Card style={{ flex: 1 }} title="Comments:" bordered={false}>
                {rfqComment}
              </Card>{' '}
              <Card style={{ flex: 1 }} title="Attachments:" bordered={false}>
                {!downloadingAttachment &&
                  <FileDetector
                    attachments={attachments}
                    onClick={(attachmentId, attachmentName) => {
                      console.log(attachmentId, attachmentName);
                      downloadAttachments(attachmentId, attachmentName);
                    }}
                  />
                }
                {downloadingAttachment && <Loading text="Downloading attachment" />}
              </Card>
            </div>
          </Panel>
        </Collapse>
      )}
      <Modal
        title="NDA"
        visible={showPdfModal}
        onOk={viewPDF}
        destroyOnClose
        onCancel={viewPDF}
        width={1000}
      >
        <div>
          <Document
            file={{
              url: `${cloudFrontCdnUrl}/${tomcatHost}/rfq/attachment/nda/${ndaObj.value}`,
              httpHeaders: { 'Authorization': `Bearer ${auth.jwtToken}` }
            }}
            onLoadSuccess={onDocumentLoadSuccess}
          >
            <Outline />
            <Page pageNumber={pageNumber} />
          </Document>
          <div>
            <p>
              Page {pageNumber || (numPages ? 1 : '--')} of {numPages || '--'}
            </p>
            <div className="help-button-container">
              <Button
                shape="circle"
                icon={<LeftOutlined />}
                disabled={pageNumber <= 1}
                onClick={previousPage}
              />
              <Button
                shape="circle"
                icon={<RightOutlined />}
                disabled={pageNumber >= numPages}
                onClick={nextPage}
              />
              <br />
              <Button
                primary
                shape="circle"
                icon={<DownloadOutlined />}
                onClick={downloadNDA}
              // title={[nFile]}
              />
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

ContractQuote.propTypes = {
  auth: PropTypes.any.isRequired,
  initialValues: PropTypes.shape({
    id: PropTypes.string,
    comment: PropTypes.string,
    deliveryDate: PropTypes.string,
    ndaAccept: PropTypes.string,
    q_machiningReq: PropTypes.string,
    q_qty: PropTypes.string,
    q_sampleAvailable: PropTypes.string,
    q_toolingAvailable: PropTypes.string,
    q_toolingDesc: PropTypes.string,
    shipping: PropTypes.string,
    status: PropTypes.string,
    unitPrice: PropTypes.string,
  }),
  totalCost: PropTypes.string.isRequired,
  attachments: PropTypes.object,

  handleFormSubmit: PropTypes.func.isRequired,
  confirmQuoteSubmit: PropTypes.func.isRequired,
  confirmQuoteCancel: PropTypes.func.isRequired,
  rfqDetails: PropTypes.array.isRequired,
  changeDate: PropTypes.func.isRequired,
  saveQuote: PropTypes.func.isRequired,
  discardQuote: PropTypes.func.isRequired,
  ndaObj: PropTypes.object.isRequired,
  showPdfModal: PropTypes.bool.isRequired,
  viewPDF: PropTypes.func.isRequired,
  downloadNDA: PropTypes.func.isRequired,
  onDocumentLoadSuccess: PropTypes.func.isRequired,
  pageNumber: PropTypes.string.isRequired,
  numPages: PropTypes.string.isRequired,
  previousPage: PropTypes.func.isRequired,
  nextPage: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  rfqObject: PropTypes.object.isRequired,
  readOnly: PropTypes.bool.isRequired,
  downloadAttachments: PropTypes.func.isRequired,
  rfqComment: PropTypes.string.isRequired,
  downloadingAttachment: PropTypes.bool.isRequired,
};

ContractQuote.defaultProps = {
  initialValues: {
    comment: '',
    deliveryDate: '',
    ndaAccept: null,
    q_machiningReq: null,
    q_qty: null,
    q_sampleAvailable: null,
    q_toolingAvailable: null,
    q_toolingDesc: null,
    shipping: null,
    status: '',
    unitPrice: null,
  },
  attachments: { '1': 'test.jpeg' },
};

export default ContractQuoteHOC(ContractQuote);



// WEBPACK FOOTER //
// ./src/pages/contractQuote/ContractQuote.jsx